<template>
	<!-- 店铺详情 -->
	<div>
		<cube-page type="myorder-view" title="店铺印象">
			<div slot="content">
				<div class="leoshop-t" :style="'background-color:'+gcfg.BackgroundColor" v-if="store != null && store != undefined" >
					<div class="shop-xx">
						<div class="shop-tx">
							<van-image :src="store.avatar" fit="scale-down" />
						</div>
						<div class="shop-xq" :style="'color:'+gcfg.TopTextColor">
							<div class="shop-name">
								<p class="name-p">
									<span class="name ells">{{store.storename}}</span>
									<span class="name-go">
										<!-- <van-icon name="arrow" /> -->
									</span>
								</p>
								<p class="shop-name-tips ells">{{store.notice}}</p>
							</div>
							<div class="btns">
							<!-- 	<van-button round v-if="!isSc" @click="handelSc">
									<van-icon name="star-o" />
									收藏
								</van-button>
								<van-button round class="ysc" v-else @click="handelSc">
									已收藏
								</van-button> -->
							</div>
						</div>
					</div>
				</div>
				<div class="leoshop-content">
					<div class="lists">
						<div class="item">
							<div class="left">
								<span>小店名称</span>
							</div>
							<div class="right">
								<span>{{store.storename}}</span>
								<div class="img">

								</div>
							</div>
						</div>
						<div class="item">
							<div class="left">
								<span>联系人</span>
							</div>
							<div class="right">
								<span>{{store.contacts}}</span>
								<div class="img">

								</div>
							</div>
						</div>
						<div class="item">
							<div class="left">
								<span>手机号码</span>
							</div>
							<div class="right">
								<span>{{store.mobile}}</span>
								<div class="img">

								</div>
							</div>
						</div>
						<div class="item">
							<div class="left">
								<span>地址</span>
							</div>
							<div class="right">
								<span>{{store.address}}</span>
								<div class="img">

								</div>
							</div>
						</div>
						<div class="item">
							<div class="left">
								<span>店宣</span>
							</div>
							<div class="right">
								<span>{{store.notice}}</span>
								<div class="img">

								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</cube-page>
	</div>

</template>

<script>
	import {
		Toast
	} from 'vant';
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	export default {
		components: {
			CubePage,
		},
		data() {
			return {
				store: null,
				gcfg: [],
				isSc: false,
				showShare: false,
				options: [
					[{
							name: '微信',
							icon: 'wechat'
						},
						{
							name: '朋友圈',
							icon: 'wechat-moments'
						},
						{
							name: '微博',
							icon: 'weibo'
						},
						{
							name: 'QQ',
							icon: 'qq'
						},
					],
					[{
							name: '复制链接',
							icon: 'link'
						},
						{
							name: '分享海报',
							icon: 'poster'
						},
						{
							name: '二维码',
							icon: 'qrcode'
						},
						{
							name: '小程序码',
							icon: 'weapp-qrcode'
						},
					],
				],
			}
		},
		methods: {
			// 收藏按钮功能
			handelSc() {
				let that = this;
				let msg = "";
				var url = "/addons/litestore/api.account/collect"
				//这里直接调用网络接口
				util.post(url, {
						store_id: that.store.id
					},
					function(result) {
						msg = result.msg;
						that.isSc = !that.isSc;
						Toast({
							message: msg
						});
					},
				);
			},
			// 点击nvabar右侧
			onClickLeft() {
				this.$router.go(-1);
			},
			// 点击nvabar左侧
			onClickRight() {
				this.showShare = true
			}
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			this.store = this.$store.getters.getShop
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			"$store.state.shop"() {
				this.store = this.$store.getters.getShop
			}
		},
	}
</script>
<style lang="less" scoped="scoped">
	@import url("../../assets/css/base.less");
	@import url("../../assets/css/listboxless.less");
</style>
<style scoped="scoped" lang="less">
	.lists {
		margin-top: 15px;
		padding: 10px 15px;
		background-color: #FFFFFF;

		.item {
			padding: 12px 0;
			display: flex;
			align-items: center;

			.left {
				width: 100px;
			}

			.right {
				width: 0;
				flex: 1;
				text-align: right;
				font-size: 14px;

				img {
					width: 200px;
				}
			}

		}

		.item+.item {
			border-top: 1px solid #f1f1f1;
		}
	}
</style>
